import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Recommended: include the full path including query params
    const pagePath = location.pathname + location.search;
    ReactGA.send({
      hitType: 'pageview',
      page: pagePath,
      title: document.title,
    });
  }, [location]);
};

export default usePageTracking;
